import GetVanRegPage from './GetVanRegPage';

export default GetVanRegPage;
